export default "__VITE_ASSET__CUo6KuJ$__"